import { useSessionQuery } from '../MsalAccessProvider';
import { useParams, Routes, Route, Navigate } from 'react-router-dom';

import Assignments from './Assignments';
import InClass from './InClass';

import loading from '../../loading.gif';

const CourseHome = () => {
  const { sectionId } = useParams();
  const { data, error, isLoading, isError } = useSessionQuery(`/cms/pushData/${sectionId}`);
  
  // wait for initial pull
  if (isLoading) {
    return (
      <div className="flex flex-col my-8">
        <div className="flex justify-center pt-4 pb-2">
          <img alt="Loading..." src={loading} className='w-12' />
        </div>
      </div>
    );
  }
  
  if (isError) {
    return (
      <div className="flex flex-col my-8">
        <div className="text-center pt-4 pb-2">
          {error}
        </div>
        <div className="text-center pt-4 pb-2">
          Please contact us at csci@utrgv.edu from your UTRGV email.
        </div>
      </div>
    );
  }

  if (!data) {
    return <></>;
  }

  // if user has no push data, this is an empty object
  const pushData = JSON.parse(data.pushData);

  /////////////////////////
  // render
  /////////////////////////

  return (
    <>
      <Routes>
        <Route path='/' element={<Navigate to='assns' />} />
        <Route path='assns/*' element={<Assignments data={pushData['assns'] || {}}/>} />
        <Route path='in-class/*' element={<InClass data={pushData['in-class'] || []}/>} />
        <Route path='midterm/*' element={<Assignments data={pushData['midterm'] || {}}/>} />
        <Route path='final/*' element={<Assignments data={pushData['final'] || {}}/>} />
        <Route path='totals_display/*' element={<InClass data={pushData['totals_display'] || []}/>} />
      </Routes>
    </>
  );
};

export default CourseHome;
